import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { authActions } from '../helpers/store';
import LogoutIcon from '@mui/icons-material/Logout';
// Argon Dashboard 2 MUI components
import ArgonBox from "../components/dashdata/ArgonBox";
import ArgonTypography from "../components/dashdata/ArgonTypography";
import DetailedStatisticsCard from "../components/dashdata/Cards/StatisticsCards/DetailedStatisticsCard";
import PaidSharpIcon from '@mui/icons-material/PaidSharp';
import PointOfSaleSharpIcon from '@mui/icons-material/PointOfSaleSharp';
import PriceCheckSharpIcon from '@mui/icons-material/PriceCheckSharp';
import ProductionQuantityLimitsSharpIcon from '@mui/icons-material/ProductionQuantityLimitsSharp';
import LinearProgress from '@mui/material/LinearProgress';
import { clearInvoices } from '../slices/invoices.slice';
import { clearStatistics, fetchStatistics } from '../slices/statistics.slice';
import GradientLineChart from "../components/dashdata/Charts/LineCharts/GradientLineChart";
import Icon from "@mui/material/Icon";
import typography from "../assets/theme/base/typography";
import { Bar, Line, Pie ,Doughnut} from "react-chartjs-2";
import Chart from 'chart.js/auto'
import { defaults } from 'chart.js';
import { clearData, clearDfaultValues, fetchDefaultValues } from '../slices/defaultValueSlice';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { clearPayment, setPostRefId } from '../slices/payment.slice';


defaults.font.family = 'mohammadfont';

const initialOptionsPie = {
  responsive: true,
  maintainAspectRatio: false,
  skipNull: true
};
const initialOptions = {
  responsive: true,
  maintainAspectRatio: false,
  pan: {
    enabled: true,
    mode: "xy"
  },
  zoom: {
    enabled: true,
    mode: "xy"
  },
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    y: {
      grid: {
        display: false
      }
    }
  },
  skipNull: true
};

const mdTheme = createTheme({
  typography: {
    fontFamily: [
      "mohammadfont",
      "Tahoma",
      "Verdana"
    ].join(",")
  },
  direction: 'rtl'
});

const lineCharConfig = {
  type: 'line',
  tension: 0.4,
  pointRadius: 0,
  borderWidth: 3,
  //borderColor: colors[dataset.color] ? colors[dataset.color || "dark"].main : colors.dark.main,
  fill: true,
  maxBarThickness: 6,

};

function DashboardContent() {
  const dispatch = useDispatch();
  const authUser = JSON.parse(localStorage.getItem('user'))
  const defaultValues = useSelector(x => x.defaultValue);
  
  const statistics = useSelector(x => x.statistics);
  useEffect(() => {

    console.log("authUser");
    console.log(authUser);
    dispatch(clearStatistics());
    dispatch(clearDfaultValues());
    dispatch(clearInvoices());
    dispatch(clearPayment());

    dispatch(fetchDefaultValues({authUser}));
    
    if(authUser.role === "CustomerPortal" || authUser.role === "FinancialPersonnel"){

      dispatch(fetchStatistics({authUser}));

    }

    //TEMP
    dispatch(setPostRefId('123abc'));     
    localStorage.setItem('oldPosRefId', '123abc');
    localStorage.setItem('oldOrderId', 456456);
    localStorage.setItem('amount', 1000);
    //TEMP

 }, []);
  
  const { size } = typography;
  

  if(!statistics.loading && statistics.items.length > 0 ){
    lineCharConfig.data = statistics.items[0];
  } 
             
  if(statistics.error || defaultValues.error)
  {
    dispatch(clearInvoices());
    dispatch(clearStatistics());
    dispatch(clearDfaultValues());
    dispatch(authActions.logout());
  }
  console.log("DASHDATA");
  console.log(authUser.role);
if(authUser.role === "CustomerPortal" || authUser.role === "FinancialPersonnel"){
  
  return (

    <ArgonBox py={3}>
    <Grid container spacing={3} mb={3}>
      <Grid item xs={12} md={6} lg={3}>
        <DetailedStatisticsCard
          title="فاکتور ها"
          count={ defaultValues.Loading ?  <LinearProgress /> : (defaultValues.CustomerSaleAndFinancialDataModel.InvoiceNetPrice !== undefined && defaultValues.CustomerSaleAndFinancialDataModel.InvoiceNetPrice !== null ? defaultValues.CustomerSaleAndFinancialDataModel.InvoiceNetPrice +  " ریال" : "")}
          icon={{ color: "info", component: <PaidSharpIcon fontSize="large" sx={{ color: '#0D47A1' }} /> }}
          percentage={{ color: "success", count: defaultValues.CustomerSaleAndFinancialDataModel.NumberofInvoices, text: "عدد در ماه جاری"  }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DetailedStatisticsCard
          title="فاکتور های برگشتی"
          count={defaultValues.Loading ?  <LinearProgress /> : (defaultValues.CustomerSaleAndFinancialDataModel.ReturnedInvoiceNetPice !== undefined && defaultValues.CustomerSaleAndFinancialDataModel.ReturnedInvoiceNetPice !== null? defaultValues.CustomerSaleAndFinancialDataModel.ReturnedInvoiceNetPice +  " ریال" : "")}
          icon={{ color: "error", component: <PointOfSaleSharpIcon fontSize="large" sx={{ color: '#33691E' }} /> }}
          percentage={{ color: "success", count: defaultValues.CustomerSaleAndFinancialDataModel.NumberofReturnedInvoices, text: "عدد در ماه جاری" }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DetailedStatisticsCard
          title="مانده حساب"
          count={defaultValues.Loading ?  <LinearProgress /> : (defaultValues.CustomerSaleAndFinancialDataModel.a8 !== undefined && defaultValues.CustomerSaleAndFinancialDataModel.a8 !== null ? defaultValues.CustomerSaleAndFinancialDataModel.a8 +  " ریال" : "")}
          icon={{ color: "success", component: <PriceCheckSharpIcon fontSize="large" sx={{ color: '#E65100' }} /> }}
          percentage={{ color: "success", count: "-", text: "-" }}
          //percentage={{ color: "error", count: "-2%", text: "سال جاری" }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <DetailedStatisticsCard
          title="مجموع پرداخت"
          count={defaultValues.Loading ?  <LinearProgress /> : (defaultValues.CustomerSaleAndFinancialDataModel.b9 !== undefined && defaultValues.CustomerSaleAndFinancialDataModel.b9 !== null ? defaultValues.CustomerSaleAndFinancialDataModel.b9+  " ریال" : "")}
          icon={{ color: "warning", component: <ProductionQuantityLimitsSharpIcon fontSize="large" sx={{ color: '#3E2723' }} /> }}
          percentage={{ color: "success", count: "-", text: "-" }}
          //percentage={{ color: "success", count: "+5%", text: "سال جاری" }}
        />
      </Grid>
    </Grid>
 {/* 
 <br/>
    <Grid container spacing={3} mb={3}>
      <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  


              <ArgonBox p={2}>
         
                <ArgonBox px={1} pt={1}>
                
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">وضعیت فروش  </ArgonTypography>
                    </ArgonBox>
                  
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک ماه
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                    <Bar data={statistics.items[0]} options={initialOptions} />
                  </div>
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>
      
   
      <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  


              <ArgonBox p={2}>
         
                <ArgonBox px={1} pt={1}>
                
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">وضعیت برگشت فروش  </ArgonTypography>
                    </ArgonBox>
                  
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک ماه
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
        

                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                  <Bar data={statistics.items[1]} options={initialOptions} />
</div>
                    
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>
      
    </Grid>

    <br/>
    <Grid container spacing={3}>
    <Grid item xs={6} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  

              <ArgonBox p={2} >    
                <ArgonBox px={1} pt={1}>            
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">{statistics.items[6].Title}</ArgonTypography>
                    </ArgonBox>
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                   به تفکیک گروه فروش از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                    <Pie data={statistics.items[6]} options={initialOptionsPie} />
                  </div>
                 
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>
      <Grid item xs={6} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  


              <ArgonBox p={2} >
         
                <ArgonBox px={1} pt={1}>
                
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">{statistics.items[7].Title}</ArgonTypography>
                    </ArgonBox>
                  
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                   به تفکیک گروه فروش از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
        

                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                    <Pie data={statistics.items[7]} options={initialOptionsPie} />
                  </div>
                 
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>


    </Grid>
    <br/>
    <Grid container spacing={3}>
    <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  
              <ArgonBox p={2} >        
                <ArgonBox px={1} pt={1}>            
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">{statistics.items[2].Title}</ArgonTypography>
                    </ArgonBox>
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک محصول از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                  <Bar data={statistics.items[2]} options={initialOptions} />
                  </div>   
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>

    <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  
              <ArgonBox p={2}>
                <ArgonBox px={1} pt={1}>
                    <ArgonBox mb={1}>
                    <ArgonTypography variant="h6">{statistics.items[3].Title}</ArgonTypography>
                    </ArgonBox>
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک محصول از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                    <Bar data={statistics.items[3]} options={initialOptions} />
                  </div>   
                  </ArgonBox>
            </ArgonBox> 
           : <span></span>)
          }
      </Grid>
    </Grid>
    <br/>
    <Grid container spacing={3}>
    <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  
              <ArgonBox p={2} >
                <ArgonBox px={1} pt={1}>
                    <ArgonBox mb={1}>
                      <ArgonTypography variant="h6">{statistics.items[4].Title}</ArgonTypography>
                    </ArgonBox>
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک محصول از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                  <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                  <Bar data={statistics.items[4]} options={initialOptions} />
                  </div>
                  </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>

    <Grid item xs={12} md={6} lg={6} sx={{ border: 1, borderRadius: 2 , borderColor: '#90CAF9' }}>
          {statistics.loading ? <LinearProgress /> :
            (statistics.items.length > 0 ?  
              <ArgonBox p={2}>
                <ArgonBox px={1} pt={1}>
                    <ArgonBox mb={1}>
                    <ArgonTypography variant="h6">{statistics.items[5].Title}</ArgonTypography>
                    </ArgonBox>
                  <ArgonBox mb={2}>
                    <ArgonTypography component="div" variant="button" fontWeight="regular" color="text">
                    به تفکیک محصول از ابتدای سال
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonBox>
                  <div style={{height:"30vh",position:"relative", marginBottom:"1%", padding:"1%"}}>
                    <Bar data={statistics.items[5]} options={initialOptions} />
                  </div>  
                </ArgonBox>
            </ArgonBox>
              
           : <span></span>)
          }
      </Grid>
    </Grid>
*/}
    {statistics.loading || defaultValues.loading ?   <Backdrop 
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>  : "" }
  </ArgonBox>
 
  );
}

return (
<span></span>
);


}

export default function Dashboard() {
  return <DashboardContent />;
}